import { render } from "./DashboardCEO.vue?vue&type=template&id=5691f958&scoped=true"
import script from "./DashboardCEO.vue?vue&type=script&lang=js"
export * from "./DashboardCEO.vue?vue&type=script&lang=js"

import "./DashboardCEO.vue?vue&type=style&index=0&id=5691f958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5691f958"]])

export default __exports__